import { Shield } from 'lucide-react';
import { LegalLayout } from '../components/legal/LegalLayout';
import styles from './legal/Legal.module.css';

export function PrivacyPolicy() {
  return (
    <LegalLayout
      label="Privacy Policy"
      title="Data & Safety"
      subtitle="How we protect your technical information and maintain strict privacy."
      lastUpdated="May 14, 2026"
    >
      <h2>1. Our Data Commitment</h2>
      <p>PCCheckr is designed with a "privacy-first" architecture. We do NOT collect, read, or upload personal files, photos, documents, passwords, browser history, clipboard data, saved WiFi passwords, or email contents.</p>
      
      <h2>2. Information We Collect</h2>
      <p>The PCCheckr scanner collects only technical system metadata necessary for hardware and software diagnostics. This includes:</p>
      <ul>
        <li>Windows version and build numbers</li>
        <li>RAM capacity, speed, and slot usage</li>
        <li>Storage drive health (SMART), capacity, and free space</li>
        <li>Battery wear levels and charge cycles</li>
        <li>System crash logs (BSOD) and driver status</li>
        <li>Startup items and running processes (for optimization)</li>
        <li>Network adapter technical status</li>
      </ul>
      
      <h2>3. Data Usage & Retention</h2>
      <p>Uploaded diagnostic (.pcc) files are used exclusively to generate your AI health report. To ensure your privacy, diagnostic data is typically anonymized or deleted after 7 days, unless you choose to retain it within your permanent account history for future comparisons.</p>
      
      <h2>4. Third-Party Services</h2>
      <p>We partner with industry-leading providers for core functionality:</p>
      <ul>
        <li><strong>Payments:</strong> Handled securely by Stripe. We never store your credit card details on our servers.</li>
        <li><strong>Authentication:</strong> Managed by Google Firebase to ensure secure login and account protection.</li>
      </ul>
      
      <h2>5. Contact Us</h2>
      <p>For any privacy-related questions or data deletion requests, please contact our support team at <a href="mailto:support@pccheckr.com">support@pccheckr.com</a>.</p>
      
      <div className={styles.trustNotice}>
        <Shield className={styles.trustIcon} size={24} />
        <p>No personal documents, passwords, photos, or browsing history are collected.</p>
      </div>
    </LegalLayout>
  );
}
